import { combineReducers } from "redux";

import userReducer from "./userReducer";
import clientDashboardReducer from "./clientDashboardReducer";
import clientDashboardReducerTemp from "./clientDashboardReducerTemp";
import layoutReducer from "./layoutReducer";

const reducer = combineReducers({
  user: userReducer,
  clientDashboard: clientDashboardReducer,
  clientDashboardTemp: clientDashboardReducerTemp,
  layoutReducer: layoutReducer
});

export default reducer;
